import script from "./IntroducingSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./IntroducingSection.vue?vue&type=script&lang=ts&setup=true"

import "./IntroducingSection.vue?vue&type=style&index=0&id=e6d27566&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6d27566"]])

export default __exports__